import {Component, Input, OnInit} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'nv-fmanager-btn',
  templateUrl: './nv-fmanager-btn.component.html',
  styles: []
})
export class NvFmanagerBtnComponent implements OnInit {

  private _document:IDocument;
  private _pointer: string;

  @Input()
  set pointer(v: string) {
    this._pointer = v;
  }

  get pointer() {
    return this._pointer;
  }

  @Input()
  set document(v:IDocument) {
    this._document = v;
  }

  get document():IDocument {
    return this._document;
  }

  constructor(private modalService:ModalService) { }

  ngOnInit() {
  }

  onClick(){
    this.modalService.showFmanager(this._document, this._pointer);
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-fmanager-btn/nv-fmanager-btn.component.ts